import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import Select, { components, DropdownIndicatorProps } from "react-select";
import Icon from "@/components/icon";
import { WeekDayType } from "@/TS/Types/global_types";
export interface DropdownOption {
  readonly value: string | number;
  readonly label: string;
  readonly isFixed?: boolean;
  readonly isDisabled?: boolean;
}
const transformToSelectOptions = (arr: Array<{
  "@id": string;
  firstName: string;
  lastName: string;
}>) => {
  return arr.map(member => {
    return {
      value: member["@id"],
      label: member.firstName + " " + member.lastName
    };
  });
};
function SelectInputContainer(t0) {
  const $ = _c(44);
  let altOptions;
  let className;
  let defaultValues;
  let fixValue;
  let label;
  let maxVal;
  let needed;
  let options;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      options,
      altOptions,
      fixValue,
      val: t1,
      label,
      maxVal,
      needed,
      required: t2,
      isMulti: t3,
      className,
      defaultValues,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = altOptions;
    $[2] = className;
    $[3] = defaultValues;
    $[4] = fixValue;
    $[5] = label;
    $[6] = maxVal;
    $[7] = needed;
    $[8] = options;
    $[9] = rest;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    altOptions = $[1];
    className = $[2];
    defaultValues = $[3];
    fixValue = $[4];
    label = $[5];
    maxVal = $[6];
    needed = $[7];
    options = $[8];
    rest = $[9];
    t1 = $[10];
    t2 = $[11];
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[13] = t1;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const val = t4;
  const required = t2 === undefined ? false : t2;
  const isMulti = t3 === undefined ? true : t3;
  const [opt, setOpt] = useState(null);
  let t5;
  let t6;
  if ($[15] !== options) {
    t5 = () => {
      if (options) {
        setOpt(transformToSelectOptions(options));
      }
    };
    t6 = [options];
    $[15] = options;
    $[16] = t5;
    $[17] = t6;
  } else {
    t5 = $[16];
    t6 = $[17];
  }
  useEffect(t5, t6);
  const DropdownIndicator = _temp;
  const t7 = "flex flex-col z-50 gap-1 " + (className ?? "");
  let t8;
  if ($[18] !== needed) {
    t8 = needed && <span className="text-primary">*</span>;
    $[18] = needed;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== label || $[21] !== t8) {
    t9 = <p className="font-bold">{label} {t8}</p>;
    $[20] = label;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      multiValue: _temp2,
      singleValue: _temp3
    };
    t11 = {
      DropdownIndicator
    };
    $[23] = t10;
    $[24] = t11;
  } else {
    t10 = $[23];
    t11 = $[24];
  }
  let t12;
  if ($[25] !== altOptions || $[26] !== opt) {
    t12 = altOptions ? altOptions : opt ?? [];
    $[25] = altOptions;
    $[26] = opt;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== maxVal || $[29] !== val.length) {
    t13 = () => val.length == (maxVal ?? 2);
    $[28] = maxVal;
    $[29] = val.length;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      option: _temp4
    };
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== defaultValues || $[33] !== fixValue || $[34] !== isMulti || $[35] !== required || $[36] !== rest || $[37] !== t12 || $[38] !== t13) {
    t15 = <Select required={required} value={fixValue} defaultValue={defaultValues} classNames={t10} components={t11} options={t12} isMulti={isMulti} isOptionDisabled={t13} className="w-full" placeholder={"S\xE9lectionner un membre"} styles={t14} theme={_temp5} {...rest} />;
    $[32] = defaultValues;
    $[33] = fixValue;
    $[34] = isMulti;
    $[35] = required;
    $[36] = rest;
    $[37] = t12;
    $[38] = t13;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t15 || $[41] !== t7 || $[42] !== t9) {
    t16 = <div className={t7}>{t9}{t15}</div>;
    $[40] = t15;
    $[41] = t7;
    $[42] = t9;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  return t16;
}
function _temp5(theme_0) {
  return {
    ...theme_0,
    borderRadius: 5,
    colors: {
      ...theme_0.colors,
      primary25: "#EE45400f",
      primary: "#EE4540"
    }
  };
}
function _temp4(styles, t0) {
  const {
    isFocused,
    isDisabled,
    isSelected,
    theme
  } = t0;
  return {
    ...styles,
    ":active": {
      ...styles[":active"],
      backgroundColor: !isDisabled ? isSelected ? theme.colors.primary : theme.colors.primary : undefined
    },
    color: isDisabled ? "#ccc" : isSelected ? "white" : isFocused ? "white" : undefined,
    backgroundColor: isDisabled ? undefined : isSelected ? theme.colors.primary : isFocused ? theme.colors.primary : undefined
  };
}
function _temp3() {
  return "!bg-light-grey !rounded-full !px-2 text-secondary w-fit";
}
function _temp2() {
  return "!bg-light-grey !rounded-full !px-2 text-dark-grey";
}
function _temp(props) {
  return <components.DropdownIndicator {...props}><Icon size={22} icon="search" className="!fill-secondary" /></components.DropdownIndicator>;
}
export default SelectInputContainer;